"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.quickOffer.name': 'Oferta Rápida',
    'tools.quickOffer.description': 'Recopila campos del formulario de oferta rápida de mensajes de usuario según los campos y opciones configurados',
};
